"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayEquals = arrayEquals;
exports.formatRoleDropDownValues = formatRoleDropDownValues;
function arrayEquals(a, b) {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
}
function formatRoleDropDownValues(data, property) {
  const roleNames = [];
  data.map(obj => {
    Object.keys(obj).forEach(prop => {
      if (prop === property && obj[prop]) {
        roleNames.push({
          value: obj[prop],
          label: obj[prop],
          name: obj[prop],
          appRoleDisplayName: obj.appRoleDisplayName,
          appRoleDescription: obj.appRoleDescription,
          appRoleObjectId: obj.appRoleObjectId
        });
      }
    });
    return roleNames;
  });
  return {
    roleNames
  };
}